import axios from "axios";

export const getProducts = () =>
  new Promise((resolve, reject) => {
    axios
      .get("/wp-json/dpe/v1/products")
      .then((resp) => {
        if (!Array.isArray(resp.data?.products)) {
          reject(new Error("Invalid products data format"));
        }
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });

export const getProductData = (params) => {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  return [
    new Promise((resolve, reject) => {
      axios
        .get("/wp-json/dpe/v1/product/data", {
          params: { json: params },
          cancelToken: source.token,
        })
        .then((resp) => {
          resolve(resp.data);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    }),
    source.cancel,
  ];
};
